import { createReducer, on } from '@ngrx/store';
import { RolesState } from './roles.model';
import * as RolesActions from './roles.actions';

export const initialState: RolesState = {
  roles: [],
  loading: false,
  error: null,
};

export const rolesReducer = createReducer(
  initialState,
  on(RolesActions.loadRoles, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(RolesActions.loadRolesSuccess, (state, { roles }) => ({
    ...state,
    roles,
    loading: false,
  })),
  on(RolesActions.loadRolesFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),
);
